/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import React, { ReactElement, useState, useCallback } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useDialogState } from '@gearz/dialog';

import { Namespaces } from '../../i18n/i18n';
import CustomDialog from '../dialog';
import { LegalTextKeys } from '../../utils/constants';

type FooterProps = {
  className?: string
};

const defaultProps = {
  className: '',
};

const { TermsOfService, PrivacyPolicy } = LegalTextKeys;
const { Common, Legal } = Namespaces;

const year = new Date().getFullYear();

interface LegalTextKey {
  snakeCase: string
  camelCase: string
}

/* eslint-disable jsx-a11y/click-events-have-key-events */

const Footer: React.FC<FooterProps> = ({ className }: FooterProps): ReactElement => {
  const { t } = useTranslation([Common, Legal]);
  const { isOpened, open: openDialog, close: closeDialog } = useDialogState();
  const [legalTextKey, setLegalTextKey] = useState<LegalTextKey | null>(null);

  const onOpenLegalText = useCallback((key: LegalTextKey): void => {
    setLegalTextKey(key);
    openDialog();
  }, [openDialog]);

  return (
    <footer className={className}>
      <div className="textAndLinks">
        <span>{t(`${Common}:footer.copyright`, { year })}</span>
        {' '}
        <Trans i18nKey={`${Common}:footer.text`}>
          <span>copyright text</span>
          {/* eslint-disable jsx-a11y/control-has-associated-label */}
          <span className="link-text" onClick={() => onOpenLegalText(TermsOfService)} role="button" tabIndex={0} />
          <span className="link-text" onClick={() => onOpenLegalText(PrivacyPolicy)} role="button" tabIndex={0} />
        </Trans>
      </div>
      {isOpened && (
        <CustomDialog isOpened={isOpened} className="legal-dialog" onClose={closeDialog}>
          <div>
            {t(`${Legal}:${legalTextKey?.snakeCase}`, {
              postProcess: 'markdown-jsx',
              overrides: { a: { props: { target: '_blank' } } },
            })}
          </div>
        </CustomDialog>
      )}
    </footer>
  );
};

Footer.defaultProps = defaultProps;

export default Footer;
